import { useTranslation } from 'react-i18next';

import { IFlightTicketRequest } from 'entities/Flights/sdk';
import { FLIGHT_TICKET_PROPOSAL_STATUS_TRANSLATION_KEY_MAP } from 'utils/constants';
import { H4, Label } from 'components/ui/typography.tsx';

const FlightBox = ({ flightTicketRequest }: { flightTicketRequest: IFlightTicketRequest }) => {
  const { t } = useTranslation();

  return (
    <a href={`/flights/offer/${flightTicketRequest.uuid}`}>
      <div className='w-[330px] h-[312px] rounded-[16px] shadow-[0_4px_4px_0_rgba(0,0,0,0.04)] flex flex-col gap-[16px]'>
        <div className={`h-[208px] p-[16px] bg-[url(src/assets/images/flights/flight1.jpg)] bg-cover rounded-t-[16px]`}>
          <Label>{t(FLIGHT_TICKET_PROPOSAL_STATUS_TRANSLATION_KEY_MAP[flightTicketRequest.computed_status])}</Label>
        </div>
        <div className='p-[16px]'>
          <H4>
            {flightTicketRequest.amount_of_people == 1
              ? t('flights.flightTitleForOnePerson')
              : t('flights.flightTitle', { peopleNumber: flightTicketRequest.amount_of_people })}
          </H4>
        </div>
      </div>
    </a>
  );
};

export default FlightBox;
